import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { FoldersService } from '../services/folders.service';

@Injectable({
  providedIn: 'root'
})
export class AllFoldersResolverService implements Resolve<boolean> {

  constructor(private folderSvc: FoldersService) { }

  resolve() {
    return this.folderSvc.loadInitialFolders();
  }
}
